import React from 'react';
import cn from 'classnames';

import RightArrowIcon from '@images/icons/16/right-arrow-icon.inline.svg';
import * as css from './ArrowIcon.module.css';

const ArrowIcon = ({ ...props }) => (
  <div
    className={cn(css.arrowIcon, props.className, {
      [css.arrowIconLight]: props.light,
    })}
  >
    <RightArrowIcon />
  </div>
);

export default ArrowIcon;
